varying vec2 vUv; 
varying vec3 vNormal; 
varying vec3 vPos; 
varying vec3 vWorldPos; 
uniform float u_fog;
uniform float u_appear;
uniform vec3 u_targetPos;



void main()
{
        vec2 ndc = (vUv -0.5)*2.;

        vec3 viewDir = normalize(cameraPosition - vWorldPos);

    // vec3 color = vec3(0.1, 0.1, 0.1);
    vec3 color = 	vec3(0.57, 0.54, 0.52)*0.1;
    float line = abs(ndc.x);
    line = smoothstep(0.99, 1., line);


 float dist = distance(vWorldPos.xz, u_targetPos.xz);
 dist =1.0 - smoothstep(0., 1.0, dist*0.25)- u_appear;
 dist =clamp(dist, 0., 1.);

    // Alpha transition douce : plein centre => 1.0, bord => 0.0


    // gl_FragColor = vec4(color, dist);
    // gl_FragColor = vec4(color, 1.);
    gl_FragColor = vec4(vec3(line*0.1), dist* line);
    // gl_FragColor = vec4(vec3(line*0.1), 1.);


}